<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <h2 mat-dialog-title>{{ title }}</h2>
  <mat-icon>drag_indicator</mat-icon>
</div>

<mat-dialog-content class="dialog-content">
  <mat-tab-group dynamicHeight="true">
    <mat-tab label="Settings">
      <!-- User Name -->
      <mat-form-field appearance="fill" class="full-width margin-sm-bottom">
        <mat-label>User Hawk Id</mat-label>
        <input matInput [(ngModel)]="user().hawkId" readonly />
      </mat-form-field>

      <!-- User Name -->
      <mat-form-field appearance="fill" class="full-width margin-sm-bottom">
        <mat-label>User Name</mat-label>
        <input matInput [(ngModel)]="user().displayName" readonly />
      </mat-form-field>

      <!-- User Email -->
      <mat-form-field appearance="fill" class="full-width margin-sm-bottom">
        <mat-label>User Email</mat-label>
        <input matInput [(ngModel)]="user().email" readonly />
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width margin-sm-bottom">
        <mat-label>Role</mat-label>
        <mat-select [(ngModel)]="roleId" (selectionChange)="setRoleId($event)">
          @for (userRole of userRoles; track userRole) {
          <mat-option [value]="userRole.roleId">{{ userRole.role.roleName }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div class="reports-to-label">Reports To</div>

      <div class="user-selector">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Who should review their timesheets?</mat-label>
          <input matInput [formControl]="reportsToControl" [matAutocomplete]="auto" />
          <mat-autocomplete #auto autoActiveFirstOption [displayWith]="displayReportsToWith"
            (optionSelected)="selectUser($event)">
            @for (user of options | async; track user) {
            <mat-option [value]="user">
              {{ user.displayName }} ({{ user.hawkId }})
            </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <div class="selected-user">
          <span>{{ selectedUser?.displayName ?? '[None selected]' }}</span>
          @if (selectedUser) {
          <button mat-icon-button (click)="selectedUser = undefined">
            <mat-icon>close</mat-icon>
          </button>
          }
        </div>
      </div>
      <div class="bits">
        <mat-checkbox [(ngModel)]="user().isDeleted">Archived</mat-checkbox>
      </div>

      <!-- User List -->
      <!-- <table mat-table [dataSource]="groupDataSource" class="mat-elevation-z8 full-width" color="primary">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Group</th>
        <td mat-cell *matCellDef="let group">{{ group.name }}</td>
      </ng-container>

      <ng-container matColumnDef="association">
        <th mat-header-cell *matHeaderCellDef>Association</th>
        <td mat-cell *matCellDef="let group">
          {{ group.groupMember?.isApprover }}
        </td>
      </ng-container>

      <ng-container matColumnDef="tools">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let group">
          <button mat-icon-button color="secondary"><mat-icon>remove</mat-icon></button>
        </td>
      </ng-container>

      <ng-container matColumnDef="footer-tools">
        <td mat-footer-cell *matFooterCellDef colspan="3" class="footer-tools"><button mat-raised-button><mat-icon>add</mat-icon> Add to group...</button></td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr mat-footer-row *matFooterRowDef="['footer-tools']"></tr>
      <colgroup>
      <col />
      <col />
      <col width="1.5em"/>
    </colgroup>
  </table> -->
    </mat-tab>
    <mat-tab label="Details">
      <div class="emp-container">
        <div class="emp-detail">
          <h3>Employee Number</h3>
          <p>{{user().employeeNumber}}</p>
        </div>
        <div class="emp-detail">
          <h3>Job Title</h3>
          <p>{{user().jobTitle}}</p>
        </div>
        <div class="emp-detail">
          <h3>Job Code</h3>
          <p>{{user().jobCode}}</p>
        </div>
        <div class="emp-detail">
          <h3>Department</h3>
          <p>{{user().departmentCode}}</p>
        </div>
        <div class="emp-detail">
          <h3>Subdepartment</h3>
          <mat-form-field appearance="fill" class="full-width" subscriptSizing="dynamic">
            <!-- <mat-label>Subdepartment</mat-label> -->
            <input matInput [(ngModel)]="user().subdeptCode" />
          </mat-form-field>
        </div>
        <div class="emp-detail">
          <h3>Pay Grade</h3>
          <p>{{user().payGrade}}</p>
        </div>
        <div class="emp-detail">
          <h3>Org ID</h3>
          <p>{{user().orgId}}</p>
        </div>
        <div class="emp-detail">
          <h3>TKS Begin Date</h3>
          <mat-form-field appearance="fill" class="full-width" subscriptSizing="dynamic">
            <mat-label>Choose a date</mat-label>
            <input matInput [matDatepicker]="picker" [(ngModel)]="user().tksBeginDate">
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="bits">
          <mat-checkbox [(ngModel)]="user().excludeFromLeaveExport">Exclude from Leave extract</mat-checkbox>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Former Details">
      <div class="emp-container">
        <div class="emp-detail">
          <h3>Employee Number</h3>
          <p>{{user().employeeNumber}}</p>
        </div>
        <div class="emp-detail">
          <h3>Former Job Title</h3>
          <p>{{user().formerJobTitle}}</p>
        </div>
        <div class="emp-detail">
          <h3>Former Job Code</h3>
          <p>{{user().formerJobCode}}</p>
        </div>
        <div class="emp-detail">
          <h3>Former Department</h3>
          <p>{{user().formerDepartmentCode}}</p>
        </div>
        <div class="emp-detail">
          <h3>Former Subdepartment</h3>
          <mat-form-field appearance="fill" class="full-width" subscriptSizing="dynamic">
            <!-- <mat-label>Subdepartment</mat-label> -->
            <input matInput [(ngModel)]="user().formerSubdeptCode" />
          </mat-form-field>
        </div>
        <div class="emp-detail">
          <h3>Former Pay Grade</h3>
          <p>{{user().formerPayGrade}}</p>
        </div>
        <div class="emp-detail">
          <h3>Former Org ID</h3>
          <p>{{user().formerOrgId}}</p>
        </div>
        <div class="emp-detail">
          <h3>Former As Of</h3>
          <p>{{user().formerRole_AsOf | date}}</p>
        </div>

        <div class="bits">
          <mat-checkbox [(ngModel)]="user().includeForFinalLeave">Include for final leave extract</mat-checkbox>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="save()">Save</button>
  <button mat-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>